module.exports = __webpack_public_path__ + "img/404.4f378d69.svg";